import vuex from "vuex";
import localStorage from "../../helper/localStorage";
import order from "../../api/order";
import http from "../../helper/http";

/**
 * 院校
 */

const state = {
  /**
   * 商家列表
   */
  shopPageList: []
}

const getters = {

}

const actions = {
  /**
   * 获取订单列表
   * @param {*} param0 
   * @param {*} params 
   */
  async getShopPageList({
    state,
    commit
  }, params) {
    let data = await http.get(`/shop/getshoppagelist?pageindex=${params.pageindex}&pagesize=${params.pagesize}`);
    return await commit('setStateData', {
        shopPageList: data
    });
  }
}

const mutations = {
  setStateData(state, params) {
    for (var key in params) {
      state[key] = params[key];
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shop.js